module.exports = __webpack_public_path__ + "img/20190531162423662.6dac5b1e.png";